import ModelView from './ModelView'

export default ModelView
